export const CARD_ROW_SELECTED_CLASSNAME = 'cardTable-selected-row';
export const EDIT_ROW_SELECTED_CLASSNAME = 'editTable-selected-row';
export const SIMPLE_ROW_SELECTED_CLASSNAME = 'simpleTable-selected-row';
export const _ROW_SELECTED_CLASSNAME = 'nctable-selected-row';
export const OPERATION_UPLOAD_CLASSNAME = 'js-upload';
